export const severities = [
  {
    label: "High",
    value: "high",
  },
  {
    label: "Medium",
    value: "medium",
  },
  {
    label: "Low",
    value: "low",
  },
];

export const ticketCategories = [
  {
    label: "Issue / Incident",
    value: "Issue / Incident",
  },
  {
    label: "Question",
    value: "Question",
  },
  {
    label: "Request / Enhancement",
    value: "Request / Enhancement",
  },
];
